import { render, staticRenderFns } from "./resume-cultures.vue?vue&type=template&id=373ed627"
import script from "./resume-cultures.vue?vue&type=script&lang=js"
export * from "./resume-cultures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports